import React from "react"
import classnames from "classnames"
import styles from "./FilterButton.module.scss"
import FilterIcon from "@material-ui/icons/FilterList"

export const FilterButton = ({ onClick }) => (
  <button
    className={classnames(
      "btn btn-small btn-dark fs-12px d-block d-md-none",
      styles["filter-button"],
    )}
    onClick={onClick}>
    <FilterIcon
      style={{ fontSize: "14px", verticalAlign: "sub", marginRight: "8px" }}
    />
    Filter
  </button>
)
